<template>
  <section>
    <settings-list
      :items="items"
      :external="false"
    />
  </section>
</template>

<script>
  import aboutIcon from '@/assets/images/illustrations/settings/tables.svg';

  import SettingsList from '@/components/Settings/List.vue';

  export default {
    name: 'About',
    components: {
      SettingsList,
    },
    data() {
      return {
        items: [{
          title: 'Termos e condições',
          description: 'Principais regras sobre o fornecimento de dados',
          icon: aboutIcon,
          url: 'https://meucredere.com.br/termos_de_uso.html',
          permissions: ['admin', 'account_manager', 'account_admin', 'sales_manager', 'store_manager', 'salesman', 'credit', 'bank_operator'],
        }, {
          title: 'Política de privacidade',
          icon: aboutIcon,
          description: 'Como a Credere coleta, trata, compartilha e armazena informações e documentos',
          url: 'https://meucredere.com.br/politica_de_privacidade.html',
          permissions: ['admin', 'account_manager', 'account_admin', 'sales_manager', 'store_manager', 'salesman', 'credit', 'bank_operator'],
        }],
      };
    },
  };
</script>

<style lang="scss" scoped></style>
